import { compare } from './sort-utils';
const compareFilms = (leftFilm, rightFilm, i18n) => {
    const displayPriorityComparison = compare(leftFilm.displayPriority, rightFilm.displayPriority);
    if (displayPriorityComparison)
        return displayPriorityComparison;
    const leftFilmTitle = i18n.translatable(leftFilm.title);
    const rightFilmTitle = i18n.translatable(rightFilm.title);
    return leftFilmTitle.localeCompare(rightFilmTitle);
};
export const sortFilmsByCxmOrder = (films, cxmFilms, i18n) => {
    const filmsExperienceOrdered = [...films].sort((leftFilm, rightFilm) => {
        let leftFilmRank = cxmFilms.map(film => film.id).indexOf(leftFilm.id);
        leftFilmRank = leftFilmRank === -1 ? Number.MAX_SAFE_INTEGER : leftFilmRank;
        let rightFilmRank = cxmFilms.map(film => film.id).indexOf(rightFilm.id);
        rightFilmRank = rightFilmRank === -1 ? Number.MAX_SAFE_INTEGER : rightFilmRank;
        return compare(leftFilmRank, rightFilmRank) || compareFilms(leftFilm, rightFilm, i18n);
    });
    return filmsExperienceOrdered;
};
export const sortFilms = (films, i18n) => {
    return [...films].sort((a, b) => compareFilms(a, b, i18n));
};
export const sortAndSliceFilms = (films, i18n, cxmFilms, maximumFilms) => {
    const sortedFilms = cxmFilms && cxmFilms.length !== 0 ? sortFilmsByCxmOrder(films, cxmFilms, i18n) : sortFilms(films, i18n);
    return sortedFilms.slice(0, maximumFilms);
};
